import OptionAccessForm from './OptionAccessForm.view';

export default OptionAccessForm;
